<script>
  export default {
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="bg-white b-b wrapper-md">
    <div class="row">
      <div class="col-md-3 col-sm-4 col-xs-12">
        <div class="m-t-sm">Administração de Leilões</div>
      </div>
      <div class="col-md-9 col-sm-8 col-xs-12">
        <ul class="nav nav-pills nav-sm">
          <router-link :to="{name: 'leilao'}" tag="li" exact><a href="">Resumo</a></router-link>
          <router-link :to="{name: 'leiloes.novo'}" tag="li" exact><a href="">Cadastro</a></router-link>
        </ul>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Header.vue?ffd441cc